module.exports = __webpack_public_path__ + "static/media/foto-especialista.11fa6b9d.jpg";